import { MessageDailyOrder } from '@model/webFeeder/daily-message.model';
import { HistoryOrder } from '@model/webFeeder/history-order.model';
import { AppUtils } from '@utils/app.utils';
import { Constants } from '@utils/constants';

export class OrdersHistoryPresenter {
  public accountsObservable;

  constructor() { }
  // cmments
  // COD WEB FEEDER             BTG	    COR
  // 0 Recebida - cinza
  // 1 Parcialmente Executada - verde
  // 5 Editada - cinza
  // 6 Cancelamento Pendente - vermelha
  // 9 Suspensa - vermelha
  // A Pendente Nova - amarela
  // E Edição pendente - amarela
  // R Recebida	  - cinza
  // EXECUTADAS
  // 2 Completamente Executada - verde
  // CANCELADAS
  // 4 Cancelada - vermelha
  // 8 Rejeitada - vermelha
  // C Expirada - vermelho



  canCancel(stateCode: string): boolean {
    if (
      stateCode === '0' || stateCode === '1' ||
      stateCode === '5' || stateCode === '6' ||
      stateCode === '9' || stateCode === 'A' ||
      stateCode === 'E' || stateCode === 'R'
    ) {
      return true;
    }

    return false;
  }

  canEdit(stateCode: string): boolean {
    if (
      stateCode === '0' || stateCode === '1' ||
      stateCode === '5' || stateCode === '6' ||
      stateCode === '9' || stateCode === 'E' ||
      stateCode === 'R'
    ) {
      return true;
    }

    return false;
  }

  openOrders(stateCode: string): boolean {
    if (
      stateCode === '0' || stateCode === '1' ||
      stateCode === '5' || stateCode === '6' ||
      stateCode === '9' || stateCode === 'A' ||
      stateCode === 'E' || stateCode === 'R'
      // TODO state === "Nova" ||
      // TODO state === "Parcialmente executada" ||
      // TODO state === "Editada" ||
      // TODO state === "Cancelamento pendente" ||
      // TODO state === "Pendente" ||
      // TODO state === "Edição pendente" ||
      // TODO state === "Recebida" ||
      // TODO state === "Pendente Nova"
    ) {
      return true;
    }

    return false;
  }

  openExecutedOrders(stateCode: string): boolean {
    if (
      stateCode === '0' || stateCode === '1' ||
      stateCode === '5' || stateCode === '6' ||
      stateCode === '9' || stateCode === 'A' ||
      stateCode === 'E' || stateCode === 'R' ||
      stateCode === '2'
    ) {
      return true;
    }

    return false;
  }

  executedOrders(stateCode: string): boolean {
    if (stateCode === '2') {
      return true;
    }

    return false;
  }

  cancelledRejectedOrders(stateCode: string): boolean {
    if (
      stateCode === '4' ||
      stateCode === '8' ||
      stateCode === 'C'
    ) {
      return true;
    }

    return false;
  }

  formatDateTimeDailyOrder(d: string) {
    const date: string = d + '';
    const day: string = date.substring(0, 2);
    const month: string = date.substring(3, 5);
    const year: string = date.substring(6, 10);
    const hour: string = date.substring(10, 13);
    const minutes: string = date.substring(14, 16);
    const dateTime: string = day + '/' + month + ' - ' + hour + 'h' + minutes;
    return dateTime;
  }

  getDiffDaysHistoryOrder(dateStart: any, dateEnd: any): Number {
    const date1 = new Date(
      dateStart.year + '/' + dateStart.month + '/' + dateStart.day
    );
    const date2 = new Date(
      dateEnd.year + '/' + dateEnd.month + '/' + dateEnd.day
    );
    return Math.ceil((date2.getTime() - date1.getTime()) / (1000 * 3600 * 24));
  }

  getTypeName(typeCode): string {
    if (typeCode === 'A' || typeCode === '1' || typeCode === '2' || typeCode === 'K') {
      return 'Normal';
    }
    return 'Disparo';
  }

  getTypeNameByCode(typeCode, name = null): string {
    switch (typeCode) {
      case '1':
        return 'Mercado com proteção';
      case '2':
        return 'Limitada';
      case '4':
        return 'Stop';
      case 'K':
        return 'Mercado Limite';
      default:
        if (name) {
          return `Check ${typeCode} maybe is ${name}`;
        } else {
          return `Checar ${typeCode}`;
        }
    }
  }

  getTimeInForce(timeInForceCode, timeInForceValue, transactTimeValue) {
    try {
      if (timeInForceCode === undefined) {
        timeInForceCode = timeInForceValue;
      }
      switch (timeInForceCode) {
        case '0':
          return 'Hoje';
        case '1':
          return 'VAC';
        case '2':
          return 'Na Abertura';
        case '3':
          return 'Executa/Cancela';
        case '4':
          return 'Tudo ou Nada';
        case '6':
          return transactTimeValue.split(' ')[0];
        case '7':
          return 'No Fechamento';
        case 'A':
          return 'Leilão';
      }
      if (timeInForceValue) {
        return timeInForceValue;
      }
      return '-';
    } catch (error) {
      return '-';
    }
  }

  transformHistoryOrder(data: any, fromHistory = true): any {
    try {
      const messageReturn: HistoryOrder[] = [];

      if (data.listBeans !== undefined) {
        data.listBeans.forEach(element => {
          try {
          if (element.securityType.value.toUpperCase() !== 'FUND' && element.securityType.value.toUpperCase() !== 'REFI' &&
            element.securityType.value.toUpperCase() !== 'TEDI') {
            const today = new Date().setHours(0, 0, 0, 0);
            const date = new Date(
              Number(element.transactTime.value.split(' ')[0].split('/')[2]),
              Number(element.transactTime.value.split(' ')[0].split('/')[1]) - 1,
              Number(element.transactTime.value.split(' ')[0].split('/')[0]),
              Number(element.transactTime.value.split(' ')[1].split(':')[0]),
              Number(element.transactTime.value.split(' ')[1].split(':')[1]),
              Number(element.transactTime.value.split(' ')[1].split(':')[2])
            );

            const dateHelper = new Date(date);

            let revertDecimal = false;
            if (element.quote.value.toLowerCase().indexOf('win') === 0 || element.quote.value.toLowerCase().indexOf('wdo') === 0 ||
              element.quote.value.toLowerCase().indexOf('dol') === 0 || element.quote.value.toLowerCase().indexOf('ind') === 0) {
              revertDecimal = false;
            } else {
              revertDecimal = true;
            }
            messageReturn.push({
              quote: element.quote?.value ?? '',
              buyOrSell: element.buyOrSell?.value ?? '',
              account: element.account?.value ?? '',
              state: AppUtils.getStatusName(element.state?.value ?? '', element.state?.code ?? ''),
              stateCode: element.state?.code ?? '',
              stateClass: this.getStatusClass(element.state?.code ?? ''),
              stateName: AppUtils.getStatusName(element.state?.value ?? '', element.state?.code ?? ''),
              quantitySupplied: element.quantitySupplied?.value ? element.quantitySupplied.value.replace('.', '').replace(',', '.') : '',
              quantityExecuted: element.quantityExecuted?.value ? element.quantityExecuted.value.replace('.', '').replace(',', '.') : '',
              quantityRemaining: element.quantityRemaining?.value ? element.quantityRemaining.value.replace('.', '').replace(',', '.') : '',
              price: AppUtils.formatPriceHistoryOrder(element.price?.value ?? '', element.quote?.value ?? '', true),
              pricePercentage: element.pricePercentage?.value ?? '',
              priceAverage: AppUtils.formatPriceHistoryOrder(element.priceAverage?.value ?? '', element.quote?.value ?? '', revertDecimal),
              type: this.getTypeNameByCode(element.type?.code ?? '', element.type?.value ?? ''),
              typeCode: element.type?.code ?? '',
              typeName: this.getTypeName(element.type?.code ?? ''),
              maturity: element.maturity?.value ?? '',
              market: element.mercado?.code ?? '',
              marketName: element.mercado?.code === 'XBSP' ? Constants.MARKET_NAME_BOVESPA : Constants.MARKET_NAME_BMF,
              canCancel: this.canCancel(element.state?.code ?? ''),
              canEdit: this.canEdit(element.state?.code ?? ''),
              timeInForce: element.timeInForce?.value ?? '',
              timeInForceCode: element.timeInForce?.code ?? '',
              timeInForceName: this.getTimeInForce(
                element.timeInForce?.code ?? '',
                element.timeInForce?.value ?? '',
                element.maturity?.value ?? ''
              ),
              transactTime: element.transactTime?.value ? element.transactTime.value.substring(0, 19) : '',
              side: element.side?.value ?? '',
              sideCode: element.side?.code ?? '',
              currentCumQty: element.currentCumQty?.value ?? '',
              currentAvgPx: element.currentAvgPx?.value ?? '',
              orderID: element.orderID?.value ?? '',
              clOrdID: element.clOrdID?.value ?? '',
              soldQty: element.soldQty?.value ?? '',
              boughtQty: element.boughtQty?.value ?? '',
              buyAvgPx: element.buyAvgPx?.value ?? '',
              sellAvgPx: element.sellAvgPx?.value ?? '',
              factor: element.factor?.value ?? '',
              username: element.username?.value ?? '',
              maxFloor: element.maxFloor?.value ?? '',
              minQty: element.minQty?.value ?? '',
              orderTag: element.orderTag?.value ?? '',
              text: element.text?.value ?? '',
              sourceAddress: element.sourceAddress?.value ?? '',
              orderStrategy: element.orderStrategy?.value ?? '',
              movingStart: element.movingStart?.value ?? '',
              initialChange: element.initialChange?.value ?? '',
              initialChangeType: element.initialChangeType?.value ?? '',
              priceStopGain: AppUtils.formatPriceHistoryOrder(element.priceStopGain?.value ?? '', element.quote?.value ?? '', revertDecimal),
              priceStop: AppUtils.formatPriceHistoryOrder(element.priceStop?.value ?? '', element.quote?.value ?? '', revertDecimal),
              price1: element.price?.value ?? '',
              price2: AppUtils.formatPriceHistoryOrder(element.price2?.value ?? '', element.quote?.value ?? '', revertDecimal),
              showDate: dateHelper.setHours(0, 0, 0, 0) === today && element.transactTime?.value ? element.transactTime.value.substring(11, 19) : AppUtils.getDateFormat(date),
              applicationDate: element.applicationDate?.value ?? '',
              mercado: element.mercado?.value ?? '',
              applicationName: element.applicationName?.value ?? ''
            });
          }
           } catch (error) {
            console.log(element)
            console.log(error)
          }
        });
      }
      return messageReturn;
    } catch (error) {
      console.log(error)
    }
  }


  transformDailyOrder(data: any, fromHistory = true): any {
    try {
      const messageReturn: MessageDailyOrder[] = [];
      data.forEach(element => {
        let revertDecimal = false;
        if (element.quote.toLowerCase().indexOf('win') === 0 || element.quote.toLowerCase().indexOf('wdo') === 0 ||
          element.quote.toLowerCase().indexOf('dol') === 0 || element.quote.toLowerCase().indexOf('ind') === 0) {
          revertDecimal = false;
        } else {
          revertDecimal = true;
        }
        messageReturn.push({
          quote: element.quote,
          buyOrSell: element.buyOrSell,
          account: element.account,
          state: AppUtils.getStatusName(element.state, element.stateCode),
          stateCode: element.stateCode,
          quantitySupplied: element.quantitySupplied ? element.quantitySupplied.replace('.', '').replace(',', '.') : null,
          quantityExecuted: element.quantityExecuted ? element.quantityExecuted.replace('.', '').replace(',', '.') : null,
          quantityRemaining: element.quantityRemaining ? element.quantityRemaining.replace('.', '').replace(',', '.') : null,
          price: element.price && element.mercado ? AppUtils.formatPriceHistoryOrder(element.price, element.mercado, true) : null,
          priceAverage: element.priceAverage && element.mercado ? AppUtils.formatPriceHistoryOrder(element.priceAverage, element.mercado, revertDecimal) : null,
          typeCode: element.typeCode,
          type: this.getTypeNameByCode(element.typeCode),
          canCancel: this.canCancel(element.stateCode),
          canEdit: this.canEdit(element.stateCode),
          // type: element.type, TODO não deletar, validação
          maturity: element.maturity,
          mercado: element.mercado === 'XBSP'
            ? Constants.MARKET_NAME_BOVESPA
            : Constants.MARKET_NAME_BMF,
          transactTime: element.transactTime ? element.transactTime.substring(0, 19) : null,
          side: element.side,
          currentCumQty: element.currentCumQty,
          currentAvgPx: element.currentAvgPx,
          orderID: element.orderID,
          orderStrategy: element.orderStrategy,
          timeInForceCode: element.timeInForceCode,
          timeInForce: element.timeInForce,
          clOrdID: element.clOrdID,
          username: element.username,
          text: element.text,
          maxFloor: element.maxFloor,
          minQty: element.minQty,
          orderTag: element.orderTag,
          movingStart: element.movingStart,
          initialChange: element.initialChange,
          applicationName: element.applicationName,
          priceStopGain: element.priceStopGain && element.quote ? AppUtils.formatPriceHistoryOrder(element.priceStopGain || '', element.quote.value, revertDecimal) : null,
          priceStop: element.priceStop && element.quote ? AppUtils.formatPriceHistoryOrder(element.priceStop || '', element.quote.value, revertDecimal) : null,
          price2: element.price2 && element.quote ? AppUtils.formatPriceHistoryOrder(element.price2 || '', element.quote.value, revertDecimal) : null,
          workingIndicator: element.workingIndicator
        });
      });
      return messageReturn;
    } catch (error) {
    }
  }

  public getStatusClass(stateCode: string) {
    // COD WEB FEEDER               COR
    // 0 Recebida - cinza
    // 1 Parcialmente Executada - verde
    // 2 Completamente Executada - verde
    // 4 Cancelada - vermelha
    // 5 Editada - cinza
    // 6 Cancelamento Pendente - vermelha
    // 8 Rejeitada - vermelha
    // 9 Suspensa - vermelha
    // A Pendente Nova - amarela
    // C Expirada - vermelho
    // E Edição pendente - amarela
    try {
      if (stateCode) {
        switch (stateCode) {
          case '0':
          case '5':
          case 'R':
            return 'status-default';
          case '1':
          case '2':
            return 'status-success';
          case '4':
          case '6':
          case '8':
          case '9':
          case 'C':
            return 'status-error';
          case 'A':
          case 'E':
            return 'status-warning';
        }
      }
      return '';
    } catch (error) {
      return '';
    }
  }

}
